import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

const FeatureToggleWrapper = ({ children = null }) => children;
const FeatureVersion = ({
  children,
  name,
  project,
  isDraft,
  live,
  staging
}) => {
  const [isActive, setActive] = useState(
    (isDraft && staging) || (!isDraft && live)
  );

  const versions = { live, staging };

  // The cookie can be set for the whole session with
  // e.g. "?featuretoggle-test=staging" to show the "staging" version of project "test"
  // e.g. "?featuretoggle-test=live" to show the "live" version of project "test"
  useEffect(
    () => {
      const override = Cookies.get(`featuretoggle-${project}`);
      if (override && versions.hasOwnProperty(override)) {
        if (versions[override]) {
          setActive(true);
        } else {
          setActive(false);
        }
      }
    },
    [project, name]
  );

  if (children && isActive) {
    return children;
  }

  return null;
};

export { FeatureVersion };
export default FeatureToggleWrapper;
